

import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;
const MAPPING_GET_URL = BASE_URL + "/compatible/check";

export const getMapping = (payload: any) => {
  return axios.post(MAPPING_GET_URL, payload);
};